var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgListView = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 1.5C1.83579 1.5 1.5 1.83579 1.5 2.25C1.5 2.66421 1.83579 3 2.25 3H21.75C22.1642 3 22.5 2.66421 22.5 2.25C22.5 1.83579 22.1642 1.5 21.75 1.5H2.25ZM2.25 7.5C1.83579 7.5 1.5 7.83579 1.5 8.25C1.5 8.66421 1.83579 9 2.25 9H21.75C22.1642 9 22.5 8.66421 22.5 8.25C22.5 7.83579 22.1642 7.5 21.75 7.5H2.25ZM1.5 14.25C1.5 13.8358 1.83579 13.5 2.25 13.5H21.75C22.1642 13.5 22.5 13.8358 22.5 14.25C22.5 14.6642 22.1642 15 21.75 15H2.25C1.83579 15 1.5 14.6642 1.5 14.25ZM2.25 19.5C1.83579 19.5 1.5 19.8358 1.5 20.25C1.5 20.6642 1.83579 21 2.25 21H21.75C22.1642 21 22.5 20.6642 22.5 20.25C22.5 19.8358 22.1642 19.5 21.75 19.5H2.25Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgListView);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/list-view.6aecaf7b6c8c0291065e858b981441b5.svg";